import { ThemeDoc } from '@livekatsomo/models';
import MoreVert from '@mui/icons-material/MoreVert';
import Star from '@mui/icons-material/Star';
import IconButton from '@mui/material/IconButton';
import ListItemButton, {
  ListItemButtonProps,
} from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';

export interface ThemeListItemProps extends ListItemButtonProps {
  theme: ThemeDoc;
  showMenu?: boolean;
  currentThemeId?: string;
  onMenuClick: (event: React.MouseEvent<HTMLElement>, theme: ThemeDoc) => void;
}

export function ThemeListItem({
  theme,
  showMenu,
  currentThemeId,
  onMenuClick,
  ...props
}: ThemeListItemProps) {
  return (
    <ListItemButton {...props}>
      <ListItemText primary={theme.name} />
      {currentThemeId === theme.id ? (
        <ListItemIcon>
          <Star />
        </ListItemIcon>
      ) : null}
      {showMenu ? (
        <ListItemSecondaryAction>
          <IconButton
            onClick={(event) => {
              event.stopPropagation();
              event.preventDefault();
              onMenuClick(event, theme);
            }}
          >
            <MoreVert />
          </IconButton>
        </ListItemSecondaryAction>
      ) : null}
    </ListItemButton>
  );
}

export default ThemeListItem;
